import React, { FC } from 'react'
import { Box } from 'transfix-ui/core'
import { TCurrencyPieChartDatum } from '../../types'
import { formatCurrencyWithPercentage } from '../utils'
import { LegendLabel } from './LegendLabel'

interface ILegendRowItemProps {
  color: string
  datum: TCurrencyPieChartDatum
  totalValues: number
}

export const LegendRowItem: FC<ILegendRowItemProps> = ({
  color,
  datum: { count, label, value },
  totalValues,
}) => {
  return (
    <Box display='table-row'>
      <Box display='table-cell' textAlign='right' width='100%'>
        <LegendLabel label={label} color={color} />
      </Box>
      <Box display='table-cell' textAlign='right' whiteSpace='nowrap'>
        {formatCurrencyWithPercentage(value, totalValues)}
      </Box>
      {count && (
        <Box display='table-cell' textAlign='right' paddingLeft={2}>
          {count}
        </Box>
      )}
    </Box>
  )
}
